const PaymentPlatforms = {
  payfabric: 'payfabric',
  globalpay: 'globalpay',
};

export default PaymentPlatforms;
